
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ztn-drawer-item",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number, Object],
      default: ""
    }
  }
})
